import {Stack, Typography, Button, Link as MuiLink, TextField, useMediaQuery} from "@mui/material";
import {useCallback, FormEvent, useState} from "react";
import {ValueWithOnchange} from "../../types";
import {LoginFooter} from "../footer";
import {PasswordTextField} from "../inputs/password";
import {OTPInput} from "../inputs/otp";
import axios from "axios";
import {Link, useParams} from "react-router-dom";
import {validateEmail} from "../../utils/email";

export const PasswordForm = ({
                               value, email, error, onChange, onSubmit,
                               twoFA, onSecretCodeChange,
                               secretCode, errorSecretCode, onReset2FA, showResetButton
                             }: ValueWithOnchange<string> &
    { email: string, error?: string, errorSecretCode?: string, onReset2FA?: () => void | Promise<void>, showResetButton?: boolean }) => {
  const handleSubmit = useCallback((e: FormEvent) => {
    e.preventDefault();
    onSubmit?.();
  }, [onSubmit]);

  const [loading, setLoading] = useState(false);
  const [restore, setRestore] = useState(false);
  const [resetNotification, setResetNotification] = useState(false);
  const [codeResetDisabled, setCodeResetDisabled] = useState(false);
  const isMobile = useMediaQuery('(max-width:500px)');

  const handleRestore = useCallback((e: any) => {
    e.preventDefault();
    setLoading(true);

    axios.post('/eus/auth/request-reset', {email}).then(() => {
      setRestore(true);
    }).finally(() => {
      setLoading(false);
    });
  }, []);

  const handleReset2FA = useCallback(() => {
    if (onReset2FA && !codeResetDisabled) {
      const result = onReset2FA();
      if (result !== undefined && typeof result.then === 'function') {
        result
          .then(() => {
            setCodeResetDisabled(true);
            setResetNotification(true);
            setTimeout(() => {
              setResetNotification(false);
            }, 5000);
          })
          .catch(() => {
          });
      } else {
        setResetNotification(true);
        setTimeout(() => {
          setResetNotification(false);
        }, 5000);
      }
    }
  }, [onReset2FA, codeResetDisabled]);

  if (restore) {
    return (
        <Stack maxWidth={isMobile ? "100%" : "816px"} padding={isMobile ? "1rem" : "3rem"} alignItems="center" spacing={4} sx={{ width: "100%", boxSizing: "border-box" }}>
          <Typography variant="h1">Проверьте почту</Typography>
          <Typography>Письмо со ссылкой на восстановление ушло на почту {email}</Typography>

          <LoginFooter/>
        </Stack>
    )
  }

  return (
      <form onSubmit={handleSubmit}>
        <Stack maxWidth={isMobile ? "100%" : "816px"} padding={isMobile ? "1rem" : "3rem"} alignItems="center" spacing={4} sx={{ width: "100%", boxSizing: "border-box" }}>
          <Typography variant="h1">Вход в систему</Typography>
          <Typography>{twoFA && !value ? (errorSecretCode === "Нет регистрации 2FA" ? "Нет регистрации 2FA" : "Введите код подтверждения") : "Введите пароль"}</Typography>

          <Stack width={isMobile ? "100%" : "454px"} spacing={2} sx={{ maxWidth: "100%" }}>
            {!twoFA || value ? (
              <PasswordTextField
                  fullWidth
                  autoFocus
                  error={!!error || !!errorSecretCode}
                  helperText={error || errorSecretCode}
                  slotProps={{
                    input: {
                      autoComplete: 'new-password',
                    }
                  }}
                  label="Пароль"
                  value={value}
                  onChange={e => onChange(e.currentTarget.value.replace(/[а-яёА-ЯЁ]/g, ''))}
              />
            ) : null}

            { twoFA && !value && (
                <>
                  {errorSecretCode !== "Нет регистрации 2FA" && (
                    <OTPInput
                      value={secretCode || ''}
                      onChange={(code) => onSecretCodeChange(code)}
                      error={!!errorSecretCode}
                      helperText={errorSecretCode}
                      length={6}
                    />
                  )}
                  {errorSecretCode === "Нет регистрации 2FA" && (
                    <Typography variant="body1" sx={{ textAlign: 'center', width: '100%', color: 'error.main' }}>
                      Нет регистрации 2FA
                    </Typography>
                  )}
                  {resetNotification && (
                    <Typography variant="caption" sx={{ textAlign: 'center', width: '100%', color: 'success.main' }}>
                      Письмо о регистрации нового кода выслано на {email}
                    </Typography>
                  )}
                </>
            )}
          </Stack>

          {/*{errorSecretCode && showResetButton && !twoFA && (*/}
          {/*  <Button */}
          {/*    size="large" */}
          {/*    variant="outlined" */}
          {/*    type="button"*/}
          {/*    onClick={handleReset2FA}*/}
          {/*    disabled={codeResetDisabled}*/}
          {/*    fullWidth={isMobile}*/}
          {/*  >*/}
          {/*    Сброс кода*/}
          {/*  </Button>*/}
          {/*)}*/}

          {twoFA && !value ? (
            <Stack direction={isMobile ? "column" : "row"} spacing={2} alignItems="center" width={isMobile ? "100%" : "auto"}>
              {/*{(onReset2FA || showResetButton) && (*/}
              {/*  <Button */}
              {/*    size="large" */}
              {/*    variant="outlined" */}
              {/*    type="button"*/}
              {/*    onClick={handleReset2FA}*/}
              {/*    disabled={codeResetDisabled}*/}
              {/*    fullWidth={isMobile}*/}
              {/*  >*/}
              {/*    Сброс кода*/}
              {/*  </Button>*/}
              {/*)}*/}
              {errorSecretCode !== "Нет регистрации 2FA" && (
                <Button size="large" disabled={!secretCode} type="submit" fullWidth={isMobile}>Войти</Button>
              )}
            </Stack>
          ) : (
            <Button size="large" disabled={!value} type="submit" fullWidth={isMobile}>Войти</Button>
          )}

          {!twoFA && (
            <Typography>Забыли пароль? <Link to="javascript:void(0);"
                                             onClick={loading ? undefined : handleRestore}><MuiLink>Восстановите</MuiLink></Link></Typography>
          )}

          <LoginFooter/>
        </Stack>
      </form>
  )
}

export const SetPassword = ({id}: { id: string }) => {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');

  const [error, setError] = useState<string>();
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const isMobile = useMediaQuery('(max-width:500px)');

  const handleSubmit = useCallback((e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    axios.post(`/eus/auth/set-password/${id}`, {password}).then(() => {
      setSent(true);
    }).finally(() => setLoading(false));
  }, [id, password]);

  if (sent) {
    return (
        <Stack maxWidth={isMobile ? "100%" : "816px"} padding={isMobile ? "1rem" : "3rem"} alignItems="center" spacing={4} sx={{ width: "100%", boxSizing: "border-box" }}>
          <Typography variant="h1">Ваш пароль изменен</Typography>
          <Typography><Link to="/"><MuiLink>Войдите в систему</MuiLink></Link></Typography>

          <LoginFooter/>
        </Stack>
    )
  }

  return (
      <form onSubmit={handleSubmit}>
        <Stack maxWidth={isMobile ? "100%" : "816px"} padding={isMobile ? "1rem" : "3rem"} alignItems="center" spacing={4} sx={{ width: "100%", boxSizing: "border-box" }}>
          <Typography variant="h1">Установите пароль</Typography>
          <Typography>Введите пароль</Typography>

          <Stack width={isMobile ? "100%" : "454px"} sx={{ maxWidth: "100%" }}>
            <PasswordTextField
                fullWidth
                autoFocus
                slotProps={{
                  input: {
                    autoComplete: 'new-password',
                  }
                }}
                label="Пароль"
                error={!!error || (!!password && !!confirm && password !== confirm)}
                helperText={(!!password && !!confirm && password !== confirm) ? "Пароли не совпадают" : error}
                value={password}
                onChange={e => setPassword(e.currentTarget.value.replace(/[а-яёА-ЯЁ]/g, ''))}
            />
          </Stack>

          <Typography>Подтвердите пароль</Typography>

          <Stack width={isMobile ? "100%" : "454px"} sx={{ maxWidth: "100%" }}>
            <PasswordTextField
                fullWidth
                autoFocus
                slotProps={{
                  input: {
                    autoComplete: 'new-password',
                  }
                }}
                error={!!error || (!!password && !!confirm && password !== confirm)}
                label="Пароль"
                value={confirm}
                onChange={e => setConfirm(e.currentTarget.value.replace(/[а-яёА-ЯЁ]/g, ''))}
            />
          </Stack>

          <Button size="large" disabled={!password || !confirm || password !== confirm}
                  type="submit">Установить пароль</Button>

          <LoginFooter/>
        </Stack>
      </form>
  )
}
